<i18n src="./resources/locales.json"></i18n>
<template>
  <div v-if="activeConversation && activeConversation.contact.number" class="header">
    <v-list-item>
      <v-list-item-avatar v-if='activeConversation.contacts.length <= 1'>
        <v-btn icon small v-if="$vuetify.breakpoint.mobile" @click="closeConversation">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <SmsAvatar v-else :contact="activeConversation.contact" :size="40" />
      </v-list-item-avatar>

      <v-list-item-content>
        <div class="group-contacts-container" v-if='activeConversation.contacts.length > 1'>
          <v-btn icon small v-if='$vuetify.breakpoint.mobile' @click='closeConversation'>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <SmsChipItem
            :key='index'
            v-for='(contact, index) in activeConversation.contacts'
            disable-close=''
            :avatar-size='28'
            :contact='contact'>
          </SmsChipItem>
        </div>
        <v-list-item-title v-if='activeConversation.contacts.length <= 1' class="font-weight-bold">
          {{ activeConversation.contact.displayName }} &nbsp;
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon size="16" v-on="on">{{ userTypeIcon }}</v-icon>
            </template>
            {{ activeConversation.contact.type ?
              $t(`${activeConversation.contact.type.toLowerCase()}`) : null
            }}
          </v-tooltip>
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-tooltip v-if='!activeConversation.isGroupConversation' left>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="downloadConversation">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          {{ $t('downloadMessages') }}
        </v-tooltip>
      </v-list-item-action>
      <v-list-item-action v-if="!isAnonymousConversation && !activeConversation.isGroupConversation">
        <SmsFavoriteContact :contact="activeConversation.contact" />
      </v-list-item-action>
    </v-list-item>

    <SmsConversationDownloaderDialog ref="conversationDownloaderDialog" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SmsConversationDownloaderDialog from '@/components/SmsConversation/SmsConversationDownloaderDialog/SmsConversationDownloaderDialog';
import SmsAvatar from '@/components/SmsAvatar/SmsAvatar';
import SmsFavoriteContact from '@/components/SmsFavoriteContact/SmsFavoriteContact';
import SmsChipItem from '@/components/SmsGroups/SmsChipItem.vue';

export default {
  name: 'SmsConversationHeader',

  components: { SmsChipItem, SmsConversationDownloaderDialog, SmsAvatar, SmsFavoriteContact },

  computed: {
    ...mapGetters('conversationsV2', ['activeConversation']),

    userTypeIcon() {
      let icon = '';
      const currentContact = this.activeConversation.contact;
      if (currentContact) {
        if (currentContact.isMobileNumber) icon = 'mdi-cellphone';
        else if (currentContact.isWorkNumber) icon = 'mdi-briefcase';
        else if (currentContact.isHomeNumber) icon = 'mdi-home';
      }
      return icon;
    },

    isAnonymousConversation() {
      return !this.activeConversation.contact.fullName;
    }
  },

  methods: {
    closeConversation() {
      this.$root.$emit('open-sidebar');
    },

    downloadConversation() {
      return this.$refs.conversationDownloaderDialog.open().catch(console.log);
    }
  }
};
</script>

<style scoped>
.header {
  border-bottom: solid 1px var(--v-surface2-border-darken1);
  background: var(--v-surface-base);
  box-shadow: 0 0 5px #0003;
  height: 59px;
}

.group-contacts-container {
  display: flex;
}
</style>
